export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const CUSTOMER_KEY = 'customer';
export const APP_VERSION_KEY = `app_version`;
export const SESSION_ID_KEY = `session_id`;
export const DEVICE_ID_KEY = `device_id`;
export const PAYMENT_SECRET_KEY = `payment_secret`;
